import {
  Button,
  Checkbox,
  CheckboxGroup,
  HStack,
  ListItem,
  UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import { SelectItem } from "../../lib/types/SelectItem";
import ModalWrapper from "../ModalWrapper";

export interface PinnedItemsModalProps {
  items: SelectItem[];
  selectedItemValues: string[];
  open: boolean;
  handleOpen: (open: boolean) => void;
  handleSave: (selectedItems: any[]) => void;
  isLoading: boolean;
  label: string;
}

export function PinnedItemsModal({
  items,
  selectedItemValues,
  open,
  handleOpen,
  handleSave,
  isLoading,
  label,
}: PinnedItemsModalProps) {
  const [selected, setSelected] = React.useState<Array<string>>([]);

  React.useEffect(() => {
    setSelected(selectedItemValues);
  }, [selectedItemValues]);

  const handleChange = (e: any) => {
    const value = e.target.value;
    onSelect(value);
  };

  const onSelect = (itemId: string) => {
    const newSelected = selected.includes(itemId)
      ? selected.filter((x: string) => x !== itemId)
      : [...selected, itemId];
    setSelected(newSelected);
  };

  const onSaveClick = () => {
    handleSave(selected);
  };

  return (
    <ModalWrapper
      isOpen={open}
      onClose={() => handleOpen(!open)}
      title={`Select ${label}`}
      size="lg"
      footer={
        <HStack spacing={4}>
          <Button onClick={() => handleOpen(!open)}>Close</Button>
          <Button
            isLoading={isLoading}
            loadingText="Saving..."
            variant="brand"
            onClick={onSaveClick}
          >
            Save Changes
          </Button>
        </HStack>
      }
    >
      <CheckboxGroup defaultValue={selectedItemValues}>
        <UnorderedList
          listStyleType="none"
          margin={0}
          maxH={400}
          overflow="auto"
        >
          {items.map((item: SelectItem) => (
            <ListItem
              paddingY={2}
              key={item.value}
              fontWeight="medium"
              marginLeft={1}
            >
              <Checkbox
                onChange={handleChange}
                spacing={4}
                value={item.value.toString()}
              >
                {`${item.label}`}
              </Checkbox>
            </ListItem>
          ))}
        </UnorderedList>
      </CheckboxGroup>
    </ModalWrapper>
  );
}
